import React, { useContext, useState } from 'react';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import useAuth from 'auth/UseAuth';
import { CancelButton } from 'components/CancelButton';
import { PrimaryButton } from 'components/PrimaryButton';
import { UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import { DialogCloseButton } from '../../components/DialogCloseButton';
import { DialogOpenButton } from '../../components/DialogOpenButton';
import { ErrorIndicator } from '../../components/ErrorIndicator';
import { LoadingIndicator } from '../../components/LoadingIndicator';
import { ErrorManagement, LoadingState } from '../../components/LoadingStateUtil';
import PipelineRulesContext, { IRuleFormInput } from '../../contexts/PipelineRulesContext';
import { CreateIssue, SdfIssue } from '../../data/SuperDuperFiestaData';

export const CreateIssueModal = ({
  setValue,
  trigger,
}: {
  setValue: UseFormSetValue<IRuleFormInput>;
  trigger: UseFormTrigger<IRuleFormInput>;
}) => {
  const { accessToken } = useAuth();

  const { pipelineFiltersDispatch, pipelineFiltersState } = useContext(PipelineRulesContext);

  const [loadingState, setLoadingState] = useState<LoadingState>({ status: 'NotStarted' });
  const [open, setOpen] = useState<boolean>(false);
  const [name, setName] = useState<string>();

  const handleOpen = async () => {
    setOpen(true);
  };

  const handleSave = async () => {
    ErrorManagement('Loading', setLoadingState, async () => {
      if (!name) {
        return;
      }

      const newIssue: SdfIssue = {
        name: name,
      };

      const response = await CreateIssue(newIssue, accessToken);
      pipelineFiltersDispatch({
        type: 'update_issues',
        issues: [response, ...pipelineFiltersState.issues],
      });
      setValue('issue', response);
      trigger('issue');
      handleClose();
    });
  };

  const handleClose = () => {
    setOpen(false);
    setName('');
    setLoadingState({ status: 'NotStarted' });
  };

  return (
    <>
      <DialogOpenButton onClick={handleOpen} sx={{ pr: 0, pl: 0, minWidth: '10%' }} />
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth='sm'>
        <DialogTitle>
          <DialogCloseButton onClick={handleClose} />
          Create Issue
        </DialogTitle>
        <DialogContent>
          <Box component='form' sx={{ flexGrow: 1, mt: 1 }}>
            <TextField
              fullWidth
              size='small'
              label='Name'
              sx={{ mb: '4px', mt: '8px' }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setName(event.target.value);
              }}
            />
          </Box>
        </DialogContent>
        <LoadingIndicator loadingState={loadingState} margin={'LR'} />
        <ErrorIndicator loadingState={loadingState} />
        <DialogActions>
          <CancelButton onClick={handleClose} disabled={loadingState.status === 'Loading'}>
            Cancel
          </CancelButton>
          <PrimaryButton onClick={handleSave} disabled={loadingState.status === 'Loading'}>
            Save
          </PrimaryButton>
        </DialogActions>
      </Dialog>
    </>
  );
};
